"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersModule = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent_1 = require("../../../../GSWrapperComponent");
var Filters_1 = require("./Filters");
var FiltersModule = /** @class */ (function (_super) {
    tslib_1.__extends(FiltersModule, _super);
    function FiltersModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FiltersModule.prototype.render = function () {
        return (React.createElement(GSWrapperComponent_1.GSWrapperComponent, { globalStore: this.props.globalStore },
            React.createElement(Filters_1.Filters, { filters: this.props })));
    };
    FiltersModule = tslib_1.__decorate([
        mobx_react_1.inject('globalStore')
    ], FiltersModule);
    return FiltersModule;
}(React.Component));
exports.FiltersModule = FiltersModule;
